<template>
  <div>
    <div v-if="comments.length == 0">
      <p v-if="type == 'customer'">
        The customer has no comments
      </p>
      <div style="text-align: right;" v-else>
        <textarea v-model="newComment" rows="20" class="pre-wrap full-width full-height"></textarea>
        <button @click="addStylistComment(newComment)">Add</button>
      </div>
    </div>
    <div v-for="comment in comments" :key="comment.id" class="border-bottom">
      <h5 class="no-margin very-small-margin-bottom" v-if="type == 'customer'">{{ comment.created_at }}</h5>
      <h5 class="no-margin very-small-margin-bottom" v-else>Comment #{{ comment.id }}</h5>
      <p class="pre-wrap" v-if="type == 'customer'">{{ comment.comment }}</p>
      <div style="text-align: right;" v-else>
        <textarea v-model="comment.comment" rows="20" class="pre-wrap full-width full-height"></textarea>
        <button @click="updateStylistComment(comment)">update</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'CommentsModalContent',
  props: {
    comments: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    },
    customerId: {
      type: Number,
      required: false
    }
  },

  data () {
    return {
      timer: null,
      newComment: ''
    }
  },

  methods: {
    updateStylistComment (comment) {
      let loader
      Vue.api.put('/stylist-comment/' + comment.id, {
        comment: comment.comment,
        user_id: comment.user_id
      }, {
        before: () => loader = this.$loading.show(),
        always: () => loader.hide()
      })
    },
    addStylistComment (comment) {
      let loader
      if (!comment) return
      Vue.api.post('stylist-comment', {
        comment: comment,
        user_id: this.customerId
      }, {
        before: () => loader = this.$loading.show(),
        always: () => loader.hide(),
        callback: () => location.reload()
      })
    },
    updateAllStylistComments () {
      this.comments.forEach(comment => {
        Vue.api.put('/stylist-comment/' + comment.id, {
          comment: comment.comment,
          user_id: comment.user_id
        }, {})
      })
    }
  },

  mounted () {
    if (this.type == 'stylist') {
      this.timer = setInterval(this.updateAllStylistComments, 10 * 1000)
    }
  },

  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style lang="less" scoped>
.pre-wrap {
  white-space: pre-wrap;
}
</style>
